import React from 'react';
// @ts-expect-error once we upgrade to more modern version with defined types we should not need this expect-error
import { axisBottom, axisLeft } from 'd3-axis';
import { ScaleLinear } from 'd3-scale';
// @ts-expect-error once we upgrade to more modern version with defined types we should not need this expect-error
import { select } from 'd3-selection';

import { Formatters } from '../ElevationChart';

import styles from './Axis.module.scss';

interface AxisProps {
  xScale: ScaleLinear<number, number, never>;
  yScale: ScaleLinear<number, number, never>;
  scopeTo?: [number, number] | null;
  height: number;
  width: number;
  formatters: Formatters;
}

export class Axis extends React.Component<AxisProps> {
  xAxisNode = React.createRef<SVGGElement>();

  yAxisNode = React.createRef<SVGGElement>();

  componentDidMount() {
    this.drawAxes();
  }

  componentDidUpdate(prevProps: Readonly<AxisProps>) {
    const { scopeTo, width, xScale, yScale } = this.props;

    const hasScopeChanged =
      prevProps?.scopeTo?.[0] !== scopeTo?.[0] ||
      prevProps?.scopeTo?.[1] !== scopeTo?.[1];

    const hasScaleChanged =
      !this.scalesAreEqual(xScale, prevProps.xScale) ||
      !this.scalesAreEqual(yScale, prevProps.yScale);

    const hasWidthChanged = prevProps.width !== width;

    if (hasScopeChanged || hasWidthChanged || hasScaleChanged) {
      this.drawAxes();
    }
  }

  scalesAreEqual = (
    scaleA: ScaleLinear<number, number, never>,
    scaleB: ScaleLinear<number, number, never>
  ) => {
    return scaleA
      .domain()
      .every((domainElement) => scaleB.domain().includes(domainElement));
  };

  drawAxes() {
    const { xScale, yScale, width, formatters } = this.props;
    const { elevationFormatter, distanceFormatter } = formatters;
    const xAxis = axisBottom(xScale);
    const yAxis = axisLeft(yScale);
    const xTickCount = width > 480 ? 8 : 4;

    yAxis
      .ticks(4)
      .tickSize(-width)
      .tickFormat((e: number) =>
        // As e here is converted/formatted value we need to unconver it
        // so that the value does not get converted twice.
        elevationFormatter.formatShort(e / elevationFormatter.convert(1.0))
      );

    xAxis.ticks(xTickCount).tickFormat((d: number) =>
      // As d here is converted/formatted value we need to unconver it
      // so that the value does not get converted twice.
      distanceFormatter.formatShort(d / distanceFormatter.convert(1.0))
    );

    yAxis(select(this.yAxisNode.current));
    xAxis(select(this.xAxisNode.current));
  }

  render() {
    const { height } = this.props;

    return (
      <>
        <g
          id="yAxis"
          className={`${styles.axis} ${styles.yAxis}`}
          ref={this.yAxisNode}
        />
        <g
          id="xAxis"
          className={`${styles.axis} ${styles.xAxis}`}
          ref={this.xAxisNode}
          transform={`translate(0, ${height})`}
        />
      </>
    );
  }
}
